import * as ambassadorWixPaymentsBalancesV5BalanceRecord from './payments-balances-v5-balance-record-balance-records.http.js';
import * as ambassadorWixPaymentsBalancesV5BalanceRecordTypes from './payments-balances-v5-balance-record-balance-records.types.js';
import * as ambassadorWixPaymentsBalancesV5BalanceRecordUniversalTypes from './payments-balances-v5-balance-record-balance-records.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getBalanceRecord(): __PublicMethodMetaInfo<
  'GET',
  { balanceRecordId: string },
  ambassadorWixPaymentsBalancesV5BalanceRecordUniversalTypes.GetBalanceRecordRequest,
  ambassadorWixPaymentsBalancesV5BalanceRecordTypes.GetBalanceRecordRequest,
  ambassadorWixPaymentsBalancesV5BalanceRecordUniversalTypes.GetBalanceRecordResponse,
  ambassadorWixPaymentsBalancesV5BalanceRecordTypes.GetBalanceRecordResponse
> {
  const payload = { balanceRecordId: ':balanceRecordId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsBalancesV5BalanceRecord.getBalanceRecord(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v5/balance-records/{balanceRecordId}',
    pathParams: { balanceRecordId: 'balanceRecordId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBalanceRecords(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsBalancesV5BalanceRecordUniversalTypes.QueryBalanceRecordsRequest,
  ambassadorWixPaymentsBalancesV5BalanceRecordTypes.QueryBalanceRecordsRequest,
  ambassadorWixPaymentsBalancesV5BalanceRecordUniversalTypes.QueryBalanceRecordsResponse,
  ambassadorWixPaymentsBalancesV5BalanceRecordTypes.QueryBalanceRecordsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsBalancesV5BalanceRecord.queryBalanceRecords(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v5/balance-records/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BalanceRecord as BalanceRecordOriginal,
  PaymentMethodType as PaymentMethodTypeOriginal,
  PaymentMethodTypeWithLiterals as PaymentMethodTypeWithLiteralsOriginal,
  PayoutInfo as PayoutInfoOriginal,
  ReserveHistoryItem as ReserveHistoryItemOriginal,
  ReserveType as ReserveTypeOriginal,
  ReserveTypeWithLiterals as ReserveTypeWithLiteralsOriginal,
  Money as MoneyOriginal,
  BalanceRecordType as BalanceRecordTypeOriginal,
  BalanceRecordTypeWithLiterals as BalanceRecordTypeWithLiteralsOriginal,
  BalanceRecordStatus as BalanceRecordStatusOriginal,
  BalanceRecordStatusWithLiterals as BalanceRecordStatusWithLiteralsOriginal,
  PaymentInfo as PaymentInfoOriginal,
  ReserveInfo as ReserveInfoOriginal,
  BookTransferInfo as BookTransferInfoOriginal,
  ListBalanceRecordsRequest as ListBalanceRecordsRequestOriginal,
  BalanceRecordTag as BalanceRecordTagOriginal,
  BalanceRecordTagWithLiterals as BalanceRecordTagWithLiteralsOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  Paging as PagingOriginal,
  ListBalanceRecordsResponse as ListBalanceRecordsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  BalanceRecordsSummary as BalanceRecordsSummaryOriginal,
  BalanceRecordsSummaryItem as BalanceRecordsSummaryItemOriginal,
  BalanceRecordsSummaryItemType as BalanceRecordsSummaryItemTypeOriginal,
  BalanceRecordsSummaryItemTypeWithLiterals as BalanceRecordsSummaryItemTypeWithLiteralsOriginal,
  GetBalanceRecordRequest as GetBalanceRecordRequestOriginal,
  GetBalanceRecordResponse as GetBalanceRecordResponseOriginal,
  QueryBalanceRecordsRequest as QueryBalanceRecordsRequestOriginal,
  Query as QueryOriginal,
  QueryBalanceRecordsResponse as QueryBalanceRecordsResponseOriginal,
  GetBalanceSummaryRequest as GetBalanceSummaryRequestOriginal,
  GetBalanceSummaryResponse as GetBalanceSummaryResponseOriginal,
  BalanceSummary as BalanceSummaryOriginal,
  ScheduledBalance as ScheduledBalanceOriginal,
  ScheduledProfileBalance as ScheduledProfileBalanceOriginal,
  ProcessingBalance as ProcessingBalanceOriginal,
  ProcessingProfileBalance as ProcessingProfileBalanceOriginal,
  Period as PeriodOriginal,
  PeriodUnit as PeriodUnitOriginal,
  PeriodUnitWithLiterals as PeriodUnitWithLiteralsOriginal,
  FundsOnHoldBalance as FundsOnHoldBalanceOriginal,
  FundsOnHoldProfileBalance as FundsOnHoldProfileBalanceOriginal,
  PayoutsBeingVerifiedBalance as PayoutsBeingVerifiedBalanceOriginal,
  PayoutsBeingVerifiedProfileBalance as PayoutsBeingVerifiedProfileBalanceOriginal,
  PayoutsUnderMinimumAmountBalance as PayoutsUnderMinimumAmountBalanceOriginal,
  PayoutsUnderMinimumAmountProfileBalance as PayoutsUnderMinimumAmountProfileBalanceOriginal,
  NegativeBalance as NegativeBalanceOriginal,
  NegativeProfileBalance as NegativeProfileBalanceOriginal,
  ReserveBalance as ReserveBalanceOriginal,
  ReserveBalanceMotivationOneOf as ReserveBalanceMotivationOneOfOriginal,
  ReserveProfileBalance as ReserveProfileBalanceOriginal,
  ReservePolicy as ReservePolicyOriginal,
  ExplicitReserve as ExplicitReserveOriginal,
  BlockedBalance as BlockedBalanceOriginal,
  BlockedProfileBalance as BlockedProfileBalanceOriginal,
  ModalData as ModalDataOriginal,
} from './payments-balances-v5-balance-record-balance-records.types.js';
